import {AxiosRequestConfig} from 'axios';
import baseHttpRequest from '@/api/base-http-request';
import pinia from '@/store/index';
import useGlobalStore from '@/store/global-store';

const global = useGlobalStore(pinia);

const spinnerHttpRequest = {
    get: async <T = any>(url: string, config?: AxiosRequestConfig) => {
        try {
            global.showSpinner();
            return await baseHttpRequest.get<T>(url, config);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            global.hideSpinner();
        }
    },
    post: async <T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig,
    ) => {
        try {
            global.showSpinner();
            return await baseHttpRequest.post<T>(url, data, config);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            global.hideSpinner();
        }
    },
    put: async <T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig,
    ) => {
        try {
            global.showSpinner();
            return await baseHttpRequest.put<T>(url, data, config);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            global.hideSpinner();
        }
    },
    patch: async <T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig,
    ) => {
        try {
            global.showSpinner();
            return await baseHttpRequest.patch<T>(url, data, config);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            global.hideSpinner();
        }
    },
    delete: async <T = any>(url: string, config?: AxiosRequestConfig) => {
        try {
            global.showSpinner();
            return await baseHttpRequest.delete<T>(url, config);
        } catch (e) {
            console.error(e);
            throw e;
        } finally {
            global.hideSpinner();
        }
    },
};

export default spinnerHttpRequest;
